import { ContentArea, HeroWithImageThematic } from "/App.Components";
import { DesignTheme } from "/App.GeneratedEnums";
import { ContentAreaItemMargin } from "/Components/Shared/ContentAreaItem/ContentAreaItem";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { InsightSectionSubPageProps } from "/Models/Generated/InsightSectionSubPageProps";
import ContentSearch from "../../Shared/Contentsearch/ContentSearch";
import "./InsightSectionSubpage.scss";

const InsightSectionSubPage = ({
  pageHeader,
  contentArea,
  hiddenH1,
  insightSearchBlock
}: InsightSectionSubPageProps) => {
  return (
    <div className="insight-section-sub-page-norad">
      {hiddenH1 && <h1 className="visually-hidden">{hiddenH1}</h1>}
      {pageHeader && (
        <HeroWithImageThematic
          {...pageHeader}
          useH2InHeader={!!hiddenH1}
          theme={DesignTheme.Insight}
        />
      )}
      <div className="insight-section-sub-page-norad__main-content">
        <ContentArea
          {...contentArea}
          contentAreaType={ContentAreaType.FullWidth}
          margin={ContentAreaItemMargin.Huge}
        />
      </div>
      {insightSearchBlock && (
        <div>
          <ContentSearch 
            insightSearchBlock={insightSearchBlock} 
          />
        </div>
      )}
    </div>
  );
};

export default InsightSectionSubPage;
